export function googlePlaceToAddress(place) {
  if (!place || !place.address_components) return null;

  const {
    address_components: addressComponents,
    formatted_address: formattedAddress,
  } = place;

  const location = {
    googleAddressObject: addressComponents,
    formattedAddress,
    locality: "", // add in locality in addition to city - rp (COC-3478)
  };

  let index = 0;
  while (!location.city && index < 3) {
    parseAddressComponents(addressComponents, location, index);
    index++;
  }

  delete location.neighborhood;
  delete location.sublocality;

  return location;
}

function parseAddressComponents(addressComponents, location, index) {
  addressComponents.forEach((c) => {
    switch (c.types[index]) {
      case "street_number":
        location.streetNumber = c.short_name;
        break;
      case "route":
        location.streetName = c.short_name;
        break;
      case "administrative_area_level_1": //  Note some countries don't have states
        location.state = c.short_name;
        break;
      case "postal_code":
        location.zip = c.short_name;
        break;
      case "country":
        location.country =
          c.long_name === "United States" ? "USA" : c.long_name;
        break;

      // the rest of the cases deal with figuring out the city name
      case "neighborhood":
        location.neighborhood = c.short_name;
        location.city = c.short_name;
        break;
      case "locality":
        location.locality = c.short_name;
        location.city = !location.neighborhood ? c.short_name : location.city;
        break;
      case "sublocality":
        location.sublocality = c.short_name;
        location.locality = location.locality || c.short_name;
        location.city =
          !location.neighborhood && !location.locality
            ? c.short_name
            : location.city;
        break;
      case "sublocality_level_1": // e.g., Brooklyn
        location.sublocality = c.short_name;
        location.locality = !location.locality
          ? c.short_name
          : location.locality;
        location.city =
          !location.locality && !location.sublocality
            ? c.short_name
            : location.city;
        break;
      case "administrative_area_level_3":
        location.city =
          !location.neighborhood && !location.locality && !location.sublocality
            ? c.short_name
            : location.city;
        break;
      case "postal_town":
        location.city =
          !location.neighborhood && !location.locality && !location.sublocality
            ? c.short_name
            : location.city;
        break;

      default:
    }
  });
  return location;
}
